import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Components/Main/MonasheeDeals/MDTechnicalAnalysis";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const MDTechnicalAnalysisTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="MDTechnicalAnalysis">
      <TabletNotice page="MDTechnicalAnalysis" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default MDTechnicalAnalysisTablet;